export default __webpack_public_path__ + "static/family-matters-fam2-e67a4f30de1e4fe247c1a759735f0047.jpg";